import {
  Compass, TrendingUp, Gauge, Target, Castle, Crown, Gem, Coins, Trophy, Handshake,
  Flame, Wrench, Sunrise, Swords, Pickaxe, Hammer, Store,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

// ⚠️ Cambia esta dirección por la de tu sitio principal (botón "Crear mi cuenta")
export const MAIN_SITE_URL = 'https://mu-vanguard.com'
export const REGISTER_URL = 'https://mu-vanguard.com/register/'
export const DOWNLOAD_URL = 'https://mu-vanguard.com/downloads'
export const DISCORD_URL = 'https://discord.com/invite/hzXpmqSjt'

export const LOGO = 'https://cdn.magicpatterns.com/uploads/te68Ekxjzq3VWFCodnkQT6/ChatGPT_Image_Mar_26,_2026,_01_29_43_AM.png'
export const HERO_BG = 'https://cdn.magicpatterns.com/uploads/eYBYRLuoC8pAFP1V97bAhQ/ChatGPT_Image_Mar_25,_2026,_10_00_56_AM.png'
export const CLOSING_BG = 'https://cdn.magicpatterns.com/uploads/7YNT4SQ2s7UKUJjcfWRYMN/ChatGPT_Image_Mar_26,_2026,_01_56_00_AM.png'

export type ChapterData = { id: string; title: string; short: string; icon: LucideIcon; status?: string }

export const chapters: ChapterData[] = [
  { id: 'largo-plazo', title: 'Un proyecto para recorrer a largo plazo', short: 'Largo plazo', icon: Compass, status: 'Visión' },
  { id: 'reset', title: 'Cada reset es un recorrido del nivel 1 al 1.000', short: 'Del 1 al 1.000', icon: TrendingUp, status: 'Visión' },
  { id: 'experiencia', title: 'Por qué la experiencia base es x50', short: 'Experiencia x50', icon: Gauge, status: 'Visión' },
  { id: 'pase', title: 'Pase de Batalla: objetivos diarios y semanales', short: 'Pase de Batalla', icon: Target, status: 'Próxima implementación' },
  { id: 'mazmorras', title: 'Mazmorras: metas a corto, mediano y largo plazo', short: 'Mazmorras', icon: Castle, status: 'Proyectado' },
  { id: 'prestigio', title: 'Gran Reset, Prestigio y Reputación', short: 'Prestigio', icon: Crown, status: 'Proyectado' },
  { id: 'drop', title: 'Por qué cuidamos el drop y los objetos', short: 'Drop y objetos', icon: Gem, status: 'Visión' },
  { id: 'vanguard-coin', title: 'Vanguard Coin y la economía del servidor', short: 'Vanguard Coin', icon: Coins, status: 'En preparación' },
  { id: 'eventos', title: 'Dos tipos de eventos: normales y premium', short: 'Eventos', icon: Trophy, status: 'En preparación' },
  { id: 'comercio', title: 'Comercio y desarrollo del personaje', short: 'Comercio', icon: Handshake, status: 'Visión' },
  { id: 'comunidad', title: 'Apoyo que vuelve a la comunidad', short: 'Comunidad', icon: Flame, status: 'Compromiso' },
  { id: 'desarrollo', title: 'Desarrollo y una administración presente', short: 'Desarrollo', icon: Wrench, status: 'Compromiso' },
  { id: 'horizonte', title: 'Esto es solo una parte del horizonte', short: 'El horizonte', icon: Sunrise },
]

export const terms = [
  { term: 'Corto plazo', example: 'Tus primeras alas, tu primer evento conquistado, la primera mazmorra.' },
  { term: 'Mediano plazo', example: 'Completar un equipo, sumar resets, preparar a tu clan para competir.' },
  { term: 'Largo plazo', example: 'Mazmorras de alto nivel, Gran Reset y un prestigio que todos reconozcan.' },
]

export const resetMotives = [
  'Visitar distintos mapas según tu progreso.',
  'Buscar recursos y mejorar tu equipo.',
  'Participar en eventos y competir por objetivos.',
  'Organizarte con otros jugadores.',
  'Elegir dónde farmear y cómo utilizar tus consumibles.',
  'Prepararte para los desafíos de la siguiente etapa.',
]

export const dungeons = [
  { req: 'Por anunciar', label: 'Primera mazmorra', note: 'Uno de los primeros objetivos del recorrido.' },
  { req: '100 resets', label: 'Mazmorra de etapa media', note: 'Desafíos y premios acordes a la preparación.' },
  { req: '300 resets', label: 'Mazmorra avanzada', note: 'Para personajes con trayectoria comprobada.' },
  { req: '500 resets', label: 'Mazmorra legendaria', note: 'Premios increíbles para quienes llegan tan lejos.' },
]

export const prestige = ['I', 'II', 'III']

export const sources = ['Farmeo', 'Eventos', 'Bosses', 'Crafteos', 'Comercio']

export const poolSteps = [
  { value: '1 VC', label: 'Costo de una entrada' },
  { value: '40', label: 'Jugadores inscritos' },
  { value: '40 VC', label: 'Pozo acumulado' },
  { value: '4 USD', label: 'Equivalente en aportes' },
]

export const playerTypes = [
  { icon: Swords, name: 'Quien compite', desc: 'Destaca en eventos, batallas y rankings.' },
  { icon: Pickaxe, name: 'Quien recolecta', desc: 'Consigue materiales, joyas y recursos.' },
  { icon: Hammer, name: 'Quien fabrica', desc: 'Combina, craftea y crea mejoras importantes.' },
  { icon: Store, name: 'Quien comercia', desc: 'Conecta lo que unos tienen con lo que otros necesitan.' },
]

export const devCommitments = [
  'Calidad de los files',
  'Estabilidad del cliente',
  'Herramientas del launcher',
  'Protección contra trampas',
  'Respuesta ante incidentes',
]
